import React from 'react';
import { Box } from '@mui/material';

import { spaces } from '../../assets/styles/themes/tokens';
import { ContentItem } from '../../types/AppContent';
import OwnCollectionOverviewWatchlistItem from './OwnCollectionOverviewWatchlistItem';

interface OwnCollectionOverviewWatchlistItemsListProps {
  pinnedCollections: ContentItem[];
  selectedIds: Set<string>;
  getItemClickHandler: (item: ContentItem) => () => void;
}

const OwnCollectionOverviewWatchlistItemsList = ({
  pinnedCollections,
  selectedIds,
  getItemClickHandler
}: OwnCollectionOverviewWatchlistItemsListProps) => {

  return (
    <Box
      data-testid='own-collection-overview-watchlist-items-list'
      sx={{ display: 'flex', flexDirection: 'column', gap: spaces.xs, paddingBottom: spaces.sm }}
    >
      {pinnedCollections.map((item) => {
        const isSelected = selectedIds.has(item.id);
        return (
          <OwnCollectionOverviewWatchlistItem
            key={item.id}
            item={item}
            isSelected={isSelected}
            onItemClick={getItemClickHandler(item)}
          />
        );
      })}
    </Box>
  );
};

export default OwnCollectionOverviewWatchlistItemsList;
